import { Injectable } from "@angular/core";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { InitService } from "@core-services/init.service";
import { ServiceNames } from "@models/service_enums";
import { FiatEarn } from "@models/derivative/currencies/fiat_earn";
import { SocketService } from "@main-services/socket.service";
import { DerivativeService } from "@main-services/currency/derivative.service";

const name = ServiceNames.FIAT_EARN;

@Injectable({
	providedIn: "root"
})
export class FiatEarnService extends DerivativeService<FiatEarn> {
	public constructor(
		protected initService: InitService,
		protected socketService: SocketService,
		protected destructor: DestructorService,
		protected translationService: TranslationService
	) {
		super(initService, destructor, translationService, socketService, name);
	}

	public logoUrl(item: FiatEarn, grayVersion: boolean = false): string {
		// This function needs to exist
		return "";
	}

	public startSockets(): void {
		// We don't have socket but this function needs to exist
	}
}
